<div class="flightDurationDs__cont flightDurationDs__cont--{{size}}">
  <div class="flightDurationDs__cont__flight-time">
    <app-ds-typography
      [size]="timeSize"
      [text]="flightTime"
      [color]="timeColor">
    </app-ds-typography>
  </div>
  <div class="flightDurationDs__cont__scales" *ngIf="!isBigger">
    <app-ds-flight-scale
      [stops]="stops">
    </app-ds-flight-scale>
  </div>
  <ng-container *ngIf="isBigger">
    <div class="flightDurationDs__cont__timeline-cont">
      <div class="flightDurationDs__cont__timeline flightDurationDs__cont__timeline--{{size}}"></div>
      <div class="flightDurationDs__cont__timeline__points flightDurationDs__cont__timeline__points--{{size}}">
        <app-ds-icon
          class="departure"
          [color]="iconColor"
          [icon]="iconDeparture"
          [size]="16">
        </app-ds-icon>
        <app-ds-icon
          class="arrival"
          [color]="iconColor"
          [icon]="iconLocation"
          [size]="16">
        </app-ds-icon>
      </div>
    </div>
  </ng-container>
  <div class="flightDurationDs__cont__labels flightDurationDs__cont__labels--{{size}}">
    <ng-container *ngIf="!isBigger">
      <app-ds-typography
        [size]="minorFontSize"
        [text]="stopsLabel"
        [color]="secondaryTextColor">
      </app-ds-typography>
    </ng-container>
    <ng-container *ngIf="isBigger">
      <div class="flightDurationDs__cont__labels__label" *ngIf="planeModel">
        <app-ds-typography
          [size]="minorFontSize"
          [text]="planeModel"
          [color]="secondaryTextColor">
        </app-ds-typography>
      </div>
      <div class="flightDurationDs__cont__labels__label" *ngIf="cabin">
        <app-ds-typography
          [size]="minorFontSize"
          [text]="cabin"
          [color]="secondaryTextColor">
        </app-ds-typography>
      </div>
      <div class="flightDurationDs__cont__labels__label" *ngIf="fare">
        <app-ds-typography
          [size]="minorFontSize"
          [text]="fare"
          [color]="secondaryTextColor">
        </app-ds-typography>
      </div>
    </ng-container>
  </div>
</div>